export default import.meta.ROLLUP_FILE_URL_Sv$J11p7Cbg3_k8XFa4MaA